import { observer } from 'mobx-react-lite';
import { HelpOther } from '@/common/helper';
import client from '@/store/client';
import { request } from "@/common";
import { useEffect, useState } from 'react';
import aiSoHomeStore from '@/pages/search-home/store';
import fieldCategoryStore from '@/components/field-category/store';
import Other from "@/common/helper/other"
import "./index.scss"

const newAgent = {
  id: "1",
  title: "AI高考填报助手",
  visitable: 1,
  intro: "您好！我是公众号文章达人，擅长各类风格。凭借对公众号文风的深入理解，迅速助力您的账号焕新出彩！您今天想写点什么呢？",
  greeting: "这是公众号文章的欢迎语：你是一位学术论文搜索与分析专家，主要任务是按用户需求搜索指定学术论文。你的任务是：1、依托学术数据库，根据关键词、研究方向、作者等多维度需求，快速定位匹配度高的中外文学术论文。2、提供合法开放并且能够获取的论文原文链接，对于需权限资源提供正规获取建议。3、可以对论文进行结构化分析，包括研究背景、核心论点、实验方法、创新点等。",
  icon: "https://p1.ssl.qhimg.com/t110b9a9301ca8de650d7a13296.png",
  creator: "纳米AI",
  agent_type: 2,
  super_switch: 0,
  limited_free: false,
  conversation_id: "",
  detail_status: 0
};

const AgentRecommand = observer(() => {
  const [agents, setAgents] = useState([]);

  useEffect(() => {
    request.get('/ai_agent/index/home_recommend_agent').then(res => {
      const agentsList = res?.data?.list || [];
      agentsList.unshift(newAgent); // 将新元素添加到数组最前面
      setAgents(agentsList);
    })
  }, [])


  return (
    <div 
      className='mt-24px w-full flex justify-center flex-wrap gap-6px agent-recommand'
    >
      {
        agents.map((agent, index) => {
          return (
            <div
              key={index}
              className={` h-40px box-border flex items-center border-1px rounded-10px px-14px gap-6px cursor-pointer agent-recommand-tab ${fieldCategoryStore.curCategoryIdx === 0 && agent.id === '1'
                  ? 'border-[#006AFF] text-[#006AFF] font-semibold bg-[#F1F5FE]'
                  : 'border-black border-opacity-10 bg-[#FDFDFD]'
                }`}
              onClick={() => {
                if (agent.id === '1') {
                  fieldCategoryStore.checkCategory(0);
                } else {
                  if (!client.isLLQ) {
                    Other.confirm({
                      title: '温馨提示',  
                      content: '前往下载页面安装最新客户端,体验完整功能',
                      onOk: () => {
                        client.openPage('/download');
                      },
                    });
                    return;
                  }
                  aiSoHomeStore.setShowCustomInputPage(true);
                  aiSoHomeStore.setCurrentAgentId(agent.id);
                }
              }}
            >
              

              <img className="size-20px rounded-full" src={agent.icon} />
              <div className=" text-14px line-clamp-1">{agent.title || ''}</div>
              {/* "New" 标签 */}
              {agent.id === '1' && (
                <div className=" top-[-5px] right-[-5px] bg-[#FF3B30] w-[31px] h-[15px] rounded-[15px] text-white px-1.5 py-0 text-[11px] font-bold flex items-center justify-center text-center leading-none">
                  New
                </div>
              )}
            </div>
          )
        })
      }
    </div>
  )
})

export default AgentRecommand;